// Report links share a single source so the Taxes menu and report tabs stay aligned.
export const TAX_REPORTS = [
  ["gstr1", "GSTR-1", "Outward sales from recorded invoices"],
  ["gstr2b", "GSTR-2B", "Purchase register; not portal-reconciled"],
  ["gstr3b", "GSTR-3B", "Estimated output tax and input tax summary"],
  ["gstr7", "GSTR-7", "GST TDS requires separate source records"],
  ["hsn", "Sale Summary by HSN", "Sales grouped by HSN/SAC"],
  ["tds_receivable", "TDS Receivable", "TDS recorded on customer invoices"],
  ["tds_payable", "TDS Payable", "TDS recorded on purchase invoices"],
  ["tcs_receivable", "TCS Receivable", "TCS recorded on purchases"],
  ["tcs_payable", "TCS Payable", "TCS recorded on sales"],
];